module.exports = __webpack_public_path__ + "media/1.87a24347.mp3";